import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import openCloseIcon from '../../images/icon_plus.svg';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import styles from './style.css';

/* eslint-disable complexity */
const AllocationHeader = ({
  headerOpen,
  toggleHeader,
  disabled,
  fundsWithCategories,
  shoppingCartEmpty
}) => {
  const { next } = useContext(FlowContext);
  const selectedFunds = fundsWithCategories;

  return (
    <div
      className="header allocation-header"
      data-name="allocationCartHeader"
      onClick={() => toggleHeader(!headerOpen)}
      onKeyDown={() => toggleHeader(!headerOpen)}
      tabIndex={0}
      role="button">
      <img
        src={openCloseIcon}
        className={`icon-plus${!headerOpen ? ' collapsed' : ''}`}
        alt="open/close cart"
      />
      My Cart{' '}
      {(disabled || shoppingCartEmpty) && <span className="cart-error-icon" />}
      <span className="count">({selectedFunds.length})</span>{' '}
      {!shoppingCartEmpty && (
        <span className="empty-cart-button">
          <MFBeaconButton
            type="button"
            data-name="emptyCartButton"
            variant="tertiary"
            label={headerOpen ? `Close` : `Edit`}
          />
        </span>
      )}
      <span className="cart-continue-button">
        <MFBeaconButton
          type="button"
          data-name="cartContinueBtn"
          variant="primary"
          size="normal"
          onClick={!disabled ? next(fundsWithCategories) : undefined}
          label="Continue"
        />
      </span>
      <style jsx>{styles}</style>
    </div>
  );
};
/* eslint-enable complexity */

export default AllocationHeader;
